var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"SDCU13u1By0z-WUHIVSEg"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["five-yards-web@118eighty8"]={id:"SDCU13u1By0z-WUHIVSEg"};
      